import { iNotificationRecord } from "@sdk/notification-inbox/notifications.models";
import { useSDKActionWithDeps } from "@sdk/sdk.hooks";
import { Button, List, Space } from "antd";
import { push } from "connected-react-router";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useDispatch, useSelector } from "react-redux";
import { selectConnectionById } from "store/modules/connections/connections.selectors";
dayjs.extend(relativeTime);

export const NotificationItem_SimplePostCommentReply = ({
  notification,
}: {
  notification: iNotificationRecord;
}) => {
  const { postId, commentId, connectionId } = notification.data as {
    type: "FB_COMMENT_REPLY";
    postId: string;
    commentId: string;
    postImage: string;
    postText: string;
    commentText: string;
    timestamp: number;
    connectionId: string;
  };

  const currentTime = new Date().getTime();

  const dispatch = useDispatch();

  const { doAction: archive } = useSDKActionWithDeps(
    () => ({
      action: (SDK) => () => SDK.dismissNotification(notification.id),
      // successMessage: "Done",
      failureMessage: "Something went wrong",
      actionDependencies: [notification.id],
    }),
    [notification.id]
  );

  const connection = useSelector(selectConnectionById(connectionId));

  return (
    <List.Item
      onClick={() => {
        console.log("commentId", commentId, connection.id);
        dispatch(
          push(
            `/conversations/Posts_Fb_${connection.id}/${postId}?commentId=${commentId}`
          )
        );
      }}
      className="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-900 rounded-lg p-4 notification-item mode_transition"
    >
      <List.Item.Meta
        avatar={
          <div className=" rounded-full bg-gray-100  dark:bg-gray-700 w-10 h-10 flex flex-row justify-center items-center font-bold mode_transition">
            <i className="ri-chat-new-line"></i>,
          </div>
        }
        title={<div className="font-bold">{notification.message}</div>}
        description={
          <div className="flex-row justify-between flex">
            <span>{dayjs(notification.createdAt).fromNow()}</span>
            <div className="actions flex flex-row justify-end items-center">
              <Space>
                {!notification.isDismissed && (
                  <Button
                    type="text"
                    onClick={(e) => {
                      archive();
                      e.stopPropagation();
                    }}
                    className="archive-button"
                  >
                    <i className="ri-inbox-archive-line"></i>
                  </Button>
                )}
              </Space>
            </div>
          </div>
        }
      />
    </List.Item>
  );
};
